import {
  Manager,
  Document
} from "./api-commons";

export interface RentProvision {
  categories: RentCategory[];
  priceList: RentPriceList;
}

export interface RentCategory {
  id: number;
  name: string;
  code: string;
  image: Document;
}

export interface RentPriceList {
  validFrom: Date;
  devices: RentDevice[];
  additionalInformations: RentPriceListAdditionalInfo[];
  manager: Manager;
}

export interface RentPriceListAdditionalInfo {
  name: string;
  items: RentPriceListAdditionalInfoItem[];
}

export interface RentPriceListAdditionalInfoItem {
  item: string;
}

export interface RentDevice {
  id: number;
  name: string;
  model?: string;
  code: string;
  description?: string; // html
  type: RentType;
  price?: number;
  price5h?: number;
  price24h?: number;
  foreignerDeposit?: number;
  accessories?: RentAccessories[];
  rentCategoryId: number;
  images: Document[];
}

export interface RentAccessories {
  id: number;
  rentDeviceId: number;
  name: string;
  type: RentType;
  price?: number;
  price5h?: number;
  price24h?: number;
  foreignerDeposit?: number;
}

export enum RentType {
  SERVICE = 'SERVICE',
  RENT = 'RENT'
}
